import React, { FC, useState } from 'react';

import {
  Box,
  Text,
  Stack,
  Modal,
  Button,
  Center,
  Heading,
  ModalBody,
  IconButton,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  CircularProgress,
} from '@chakra-ui/react';

import { MdArrowBack, MdUploadFile } from 'react-icons/md';

import { Form, Formik } from 'formik';

import Dropzone, { DropzoneProps } from 'react-dropzone';

import FormikSelectInput from 'components/primitives/FormikSelectInput';

import { Values, UploadCSVModalViewProps } from './UploadCSVModal.props';

const UploadCSVModalView: FC<UploadCSVModalViewProps> = (props) => {
  const {
    skus,
    type,
    isOpen,
    onClose,
    onUpload,
    isLoading,
    isLoadingSku,
  } = props;

  const [values, setValues] = useState<Values>(null);
  const [isForm, setIsForm] = useState<boolean>(true);

  const onDrop: DropzoneProps['onDrop'] = (files) => {
    const file = files?.[0];

    if (file) {
      onUpload(file, values, () => {
        setIsForm(true);
        setValues(null);
      });
    }
  };

  return (
    <Modal
      size="6xl"
      isCentered
      isOpen={isOpen}
      onClose={() => {
        setIsForm(true);
        setValues(null);

        onClose();
      }}
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="30px" overflow="hidden">
        {!isForm && (
          <IconButton
            aria-label="back-icon"
            icon={<MdArrowBack size="20px" color="#4f4f4f" />}
            variant="ghost"
            size="sm"
            w="25px"
            position="absolute"
            left={3}
            top={2}
            onClick={() => setIsForm(true)}
          />
        )}
        <ModalHeader textAlign="center" fontSize="xl" color="support.200">
          {isForm ? `Add new ${type}` : 'Upload your file'}
        </ModalHeader>
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalBody px={10} py={10}>
          {isForm ? (
            <Formik
              initialValues={values ?? { sku: '' }}
              onSubmit={(values) => {
                setValues(values);
                setIsForm(false);
              }}>
              {({ values }) => (
                <Form>
                  <Stack mb={4} spacing={4}>
                    <Stack align="flex-end" isInline>
                      <FormikSelectInput
                        isLoading={isLoadingSku}
                        label={`Select ${
                          type === 'case' ? 'case' : ''
                        } SKU (*)`}
                        placeholder="Select"
                        name="sku">
                        {skus.map((r, i) => (
                          <option value={r._id} key={`${r._id}-${i}`}>
                            {r.name}
                          </option>
                        ))}
                      </FormikSelectInput>
                      <Box h="20px" w="10px" />
                      {/* <FormikSelectInput
                        placeholder="Select"
                        label="Origin Wash Hub (*)"
                        name="washHub">
                        {washHubs?.map((w) => (
                          <option key={w._id} value={w._id}>
                            {w?.name || ''}
                          </option>
                        ))}
                      </FormikSelectInput> */}
                    </Stack>
                    <Center>
                      <Button
                        mr={4}
                        w="150px"
                        onClick={() => {
                          setIsForm(true);
                          setValues(null);

                          onClose();
                        }}
                        isDisabled={isLoading}>
                        Cancel
                      </Button>
                      <Button w="150px" type="submit" isDisabled={!values?.sku}>
                        Upload File
                      </Button>
                    </Center>
                  </Stack>
                </Form>
              )}
            </Formik>
          ) : (
            <Dropzone accept={['.csv']} onDrop={onDrop}>
              {({ getInputProps, getRootProps }) => {
                return (
                  <Center
                    {...(getRootProps() as any)}
                    flex={1}
                    w="100%"
                    h="300px"
                    bg="primary.900"
                    border="2px dashed #2FB64A"
                    borderRadius="10px"
                    flexDirection="column">
                    <MdUploadFile size="50px" color="primary.500" />
                    <Heading fontSize="xl" my={4} color="support.200">
                      Select a file or drag and drop here
                    </Heading>
                    <Text>Your file must be CSV or XSL</Text>
                    {isLoading ? (
                      <Stack my={5} align="center">
                        <CircularProgress isIndeterminate />
                        <Text>Your File is being uploaded</Text>
                      </Stack>
                    ) : (
                      <Button mt={4} size="lg">
                        Select File
                      </Button>
                    )}
                    <input {...getInputProps()} style={{ display: 'none' }} />
                  </Center>
                );
              }}
            </Dropzone>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default UploadCSVModalView;
